// export const server = "http://localhost:5005/api/v1";
export const server = "https://developerserver.bravishmah.com/api/v1";
export const backupServer = "https://backupserver.appdeploy.in/api/v1";
export const tinyApiKey = "u2j0p691ks3c6dphfk92onc7d3w2jzios9fswzwkak2vsysf";

export const DAY = 1000 * 24 * 60 * 60;

export const defaultUserImage = "";
